import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useCpvCodes } from "./useCpvCodes";

export type CpvDivision = { code: string; name: string };

const DIVISION = /^\d{2}0{6}$/;

export type UseCpvDivisionsResult = {
  divisions: CpvDivision[];
  nameOf: (code: string | null | undefined) => string | null;
  isLoading: boolean;
  isError: boolean;
};

export const useCpvDivisions = (): UseCpvDivisionsResult => {
  const { codes, isLoading, isError } = useCpvCodes();
  const { i18n } = useTranslation();
  const norwegian = i18n.language.startsWith("no") || i18n.language.startsWith("nb");
  const divisions = useMemo(
    () =>
      codes
        .filter((code) => DIVISION.test(code.code))
        .map((code) => ({ code: code.code, name: (norwegian ? code.nameNb : code.nameEn) || code.nameEn }))
        .sort((a, b) => a.code.localeCompare(b.code)),
    [codes, norwegian],
  );
  const nameOf = (code: string | null | undefined) =>
    code ? divisions.find((division) => division.code === code)?.name ?? code : null;
  return { divisions, nameOf, isLoading, isError };
};
